// This array and the following code, is required to get the correct name of the model, after everything is built and minified.
// It not the constructor.name directly, because minification changes the names of the classes.
let models = [
  "AppRecord",
  "AssetClassInvestment",
  "Client",
  "Coract",
  "Covariance",
  "Document",
  "DocumentPrivilege",
  "DocumentRelation",
  "DocumentGroup",
  "DocumentNote",
  "Administrator",
  "Employee",
  "BankContact",
  "VehicleCostEstimate",
  "Issue",
  "IssueInvestment",
  "AccountInvestment",
  "FeeInvestment",
  "InvestmentAggregation",
  "IssueAggregation",
  "TotalInvestment",
  "Entity",
  "EntityRelation",
  "Account",
  "AccountRate",
  "Fee",
  "FeeRate",
  "ContactInformation",
  "PersonConsultant",
  "CurrencyRate",
  "Deposit",
  "InvestmentCost",
  "LaunderingEvent",
  "Event",
  "Investment",
  "LossWarning",
  "MeetingSummary",
  "Ownership",
  "Trade",
  "Price",
  "User",
  "Route",
  "InvestmentReport",
  "InvestmentCostReport",
  "LossWarningNotification",
  "Currency",
  "IncomeReceived",
  "IncomeCancel",
  "Income",
  "IncomeTrade",
  "TradeCost",
  "ApplicationRecordLog",
  "Onboarding",
  "OnboardingStep",
  "OnboardingStepDatum",
  "AllocationLimit",
  "RiskAssessment",
  "TradeSuggestion",
  "EventLoad",
  "EventLoadLog",
  "LossWarningLoss",
  "AssetClassGroup",
  "BenchmarkSetup",
  "BenchmarkWeight",
  "InvoiceType",
  "IssueTaxStructure",
  "ManualFee",
  "EntityCommitment",
  "EntityInvoiceType",
  "SailsLog",
  "SailsLogCheck",
  "MailGroup",
  "MailGroupUser",
  "SailsLogSubscription",
  "EntityInvoiceFee",
  "Reporting",
  "ReportingType",
  "EntityAllocation",
  "EntityVehicleCostEstimate",
  "EventRefundSplit",
  "IssueFundGroup",
  "Bank",
  "EntityBenchmark",
  "SailsHelpText",
  "TransactionRule",
  "AccountBalance",
  "DepositBalance",
  "IsinMapping",
  "BankImportRule",
  'DepositReconciliationHistory',
  'EntityCost',
  'EntityCostType',
  'EntityCostName',
  "UpdateMessagePolicy",
  'DataStaging',
  'DataStagingLog',
  "Aif",
  "AifCommitment",
  "AifTransaction",
  "AifCommitmentTransaction",
  "EntityPrice",
  "FeePayment",
  "FeeCancel",
  "FeeExpected",
  "RefundExpected",
  "RefundCancel",
  "Refund",
  "TradeExpected",
  "TradeCancel",
  "TradeCostExpected",
  "TradeCostCancel"
];

(async () => {
  for (const name of models) {
    let module = await import(`stores/models/modelFiles/${name}.js`);
    let klass = module.default;
    klass.prototype.__defineGetter__("constructor_name", function () {
      return name;
    });
  }
})();

export { default as AppRecord } from "./modelFiles/AppRecord";
export { default as AssetClassInvestment } from "./modelFiles/AssetClassInvestment";
export { default as Client } from "./modelFiles/Client";
export { default as Coract } from "./modelFiles/Coract";
export { default as Covariance } from "./modelFiles/Covariance";
export { default as Document } from "./modelFiles/Document";
export { default as DocumentNote } from "./modelFiles/DocumentNote";
export { default as DocumentPrivilege } from "./modelFiles/DocumentPrivilege";
export { default as DocumentRelation } from "./modelFiles/DocumentRelation";
export { default as DocumentGroup } from "./modelFiles/DocumentGroup";
export { default as Administrator } from "./modelFiles/Administrator";
export { default as Employee } from "./modelFiles/Employee";
export { default as BankContact } from "./modelFiles/BankContact";
export { default as VehicleCostEstimate } from "./modelFiles/VehicleCostEstimate";
export { default as Issue } from "./modelFiles/Issue";
export { default as IssueInvestment } from "./modelFiles/IssueInvestment";
export { default as AccountInvestment } from "./modelFiles/AccountInvestment";
export { default as FeeInvestment } from "./modelFiles/FeeInvestment";
export { default as InvestmentAggregation } from "./modelFiles/InvestmentAggregation";
export { default as IssueAggregation } from "./modelFiles/IssueAggregation";
export { default as TotalInvestment } from "./modelFiles/TotalInvestment";
export { default as Entity } from "./modelFiles/Entity";
export { default as EntityRelation } from "./modelFiles/EntityRelation";
export { default as Account } from "./modelFiles/Account";
export { default as AccountRate } from "./modelFiles/AccountRate";
export { default as Fee } from "./modelFiles/Fee";
export { default as FeeRate } from "./modelFiles/FeeRate";
export { default as ContactInformation } from "./modelFiles/ContactInformation";
export { default as PersonConsultant } from "./modelFiles/PersonConsultant";
export { default as CurrencyRate } from "./modelFiles/CurrencyRate";
export { default as Deposit } from "./modelFiles/Deposit";
export { default as InvestmentCost } from "./modelFiles/InvestmentCost";
export { default as LaunderingEvent } from "./modelFiles/LaunderingEvent";
export { default as Event } from "./modelFiles/Event";
export { default as Investment } from "./modelFiles/Investment";
export { default as LossWarning } from "./modelFiles/LossWarning";
export { default as MeetingSummary } from "./modelFiles/MeetingSummary";
export { default as Ownership } from "./modelFiles/Ownership";
export { default as Trade } from "./modelFiles/Trade";
export { default as Price } from "./modelFiles/Price";
export { default as User } from "./modelFiles/User";
export { default as Route } from "./modelFiles/Route";
export { default as InvestmentReport } from "./modelFiles/InvestmentReport";
export { default as InvestmentCostReport } from "./modelFiles/InvestmentCostReport";
export { default as LossWarningNotification } from "./modelFiles/LossWarningNotification";
export { default as Currency } from "./modelFiles/Currency";
export { default as IncomeReceived } from "./modelFiles/IncomeReceived";
export { default as IncomeCancel } from "./modelFiles/IncomeCancel";
export { default as Income } from "./modelFiles/Income";
export { default as IncomeTrade } from "./modelFiles/IncomeTrade";
export { default as TradeCost } from "./modelFiles/TradeCost";
export { default as ApplicationRecordLog } from "./modelFiles/ApplicationRecordLog";
export { default as Onboarding } from "./modelFiles/Onboarding";
export { default as OnboardingStep } from "./modelFiles/OnboardingStep";
export { default as OnboardingStepDatum } from "./modelFiles/OnboardingStepDatum";
export { default as AllocationLimit } from "./modelFiles/AllocationLimit";
export { default as RiskAssessment } from "./modelFiles/RiskAssessment";
export { default as TradeSuggestion } from "./modelFiles/TradeSuggestion";
export { default as EventLoad } from "./modelFiles/EventLoad";
export { default as EventLoadLog } from "./modelFiles/EventLoadLog";
export { default as LossWarningLoss } from "./modelFiles/LossWarningLoss";
export { default as AssetClassGroup } from "./modelFiles/AssetClassGroup";
export { default as EntityReportingGroup } from "./modelFiles/EntityReportingGroup";
export { default as BenchmarkSetup } from "./modelFiles/BenchmarkSetup";
export { default as BenchmarkWeight } from "./modelFiles/BenchmarkWeight";
export { default as InvoiceType } from "./modelFiles/InvoiceType";
export { default as InvoiceTypeInterval } from "./modelFiles/InvoiceTypeInterval";
export { default as InvoiceTypeIntervalLine } from "./modelFiles/InvoiceTypeIntervalLine";
export { default as PersonFamily } from "./modelFiles/PersonFamily";
export { default as IssueTaxStructure } from "./modelFiles/IssueTaxStructure";
export { default as EntityInvoiceType } from "./modelFiles/EntityInvoiceType";
export { default as ManualFee } from "./modelFiles/ManualFee";
export { default as EntityCommitment } from "./modelFiles/EntityCommitment";
export { default as DataSelector } from "./modelFiles/DataSelector";
export { default as SailsLog } from "./modelFiles/SailsLog";
export { default as SailsLogCheck } from "./modelFiles/SailsLogCheck";
export { default as MailGroup } from "./modelFiles/MailGroup";
export { default as MailGroupUser } from "./modelFiles/MailGroupUser";
export { default as MailGroupAction } from "./modelFiles/MailGroupAction";
export { default as EntityInvoiceFee } from "./modelFiles/EntityInvoiceFee";
export { default as Reporting } from "./modelFiles/Reporting";
export { default as ReportingType } from "./modelFiles/ReportingType";
export { default as EntityAllocation } from "./modelFiles/EntityAllocation";
export { default as EntityVehicleCostEstimate } from "./modelFiles/EntityVehicleCostEstimate";
export { default as EventRefundSplit } from "./modelFiles/EventRefundSplit";
export { default as IssueFundGroup } from "./modelFiles/IssueFundGroup";
export { default as Bank } from "./modelFiles/Bank";
export { default as EntityBenchmark } from "./modelFiles/EntityBenchmark";
export { default as TransactionRule } from "./modelFiles/TransactionRule";
export { default as AccountBalance } from "./modelFiles/AccountBalance";
export { default as DepositBalance } from "./modelFiles/DepositBalance";
export { default as IsinMapping } from "./modelFiles/IsinMapping";
export { default as BankImportRule } from "./modelFiles/BankImportRule";
export { default as DepositReconciliationHistory } from "./modelFiles/DepositReconciliationHistory";
export { default as EntityCost } from "./modelFiles/EntityCost";
export { default as EntityCostType } from "./modelFiles/EntityCostType";
export { default as EntityCostName } from "./modelFiles/EntityCostName";
export { default as UpdateMessagePolicy } from "./modelFiles/UpdateMessagePolicy";
export { default as DataStaging } from "./modelFiles/DataStaging";
export { default as DataStagingLog } from "./modelFiles/DataStagingLog";
export { default as Aif } from "./modelFiles/Aif";
export { default as AifCommitment } from "./modelFiles/AifCommitment";
export { default as AifTransaction } from "./modelFiles/AifTransaction";
export { default as AifCommitmentTransaction } from "./modelFiles/AifCommitmentTransaction";
export { default as EntityPrice } from "./modelFiles/EntityPrice";
export { default as FeePayment } from "./modelFiles/FeePayment";
export { default as FeeCancel } from "./modelFiles/FeeCancel";
export { default as FeeExpected } from "./modelFiles/FeeExpected";
export { default as RefundExpected } from "./modelFiles/RefundExpected";
export { default as RefundCancel } from "./modelFiles/RefundCancel";
export { default as Refund } from "./modelFiles/Refund";
export { default as TradeExpected } from "./modelFiles/TradeExpected";
export { default as TradeCancel } from "./modelFiles/TradeCancel";
export { default as TradeCostExpected } from "./modelFiles/TradeCostExpected";
export { default as TradeCostCancel } from "./modelFiles/TradeCostCancel";
